import React, { useContext, useState, useRef, useEffect } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//pages & includes
import ManageSidebar from "../ManageSidebar";
import ItemMultiSelectModalForItem from "../../../../components/Common/ItemMultiSelectModalForItem";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";

const remarksOptions = [
  { label: "Fastfood", value: "Fastfood" },
  { label: "Karahi (Pakistani)", value: "Karahi (Pakistani)" },
  { label: "Bar", value: "Bar" },
  { label: "Chinese", value: "Chinese" },
  { label: "BBQ", value: "BBQ" },
  { label: "Tandoor", value: "Tandoor" },
  { label: "Breakfast", value: "Breakfast" },
  { label: "Ban Marie (Pakistani)", value: "Ban Marie (Pakistani)" },
  { label: "Continental", value: "Continental" },
  { label: "Allmed", value: "Allmed" },
  { label: "Patient Meal", value: "Patient Meal" },
  { label: "Floor & House Keeping", value: "Floor & House Keeping" },
  { label: "Custom", value: "Custom" },
];

const StoreRequisitionAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  const search = useLocation().search;
  const isDuplicate = Boolean(new URLSearchParams(search).get("duplicate"));
  const { qtyAmountPoints, roundOffStock } = useCustomHooks();

  let {
    loading,
    setLoading,
    branchForSearch,
    branchListWeb,
    ingredientItemForSearch,
  } = useContext(RestaurantContext);

  let { setStoreRequisitionList, setStoreRequisitionForSearch } =
    useContext(UserContext);

  let [newStoreRequisition, setNewStoreRequisition] = useState({
    document_no: "",
    fbranch: null,
    tbranch: null,
    remarks: "",
    selectedRemark: null,
    is_post: 0,
  });

  const [newRow, setNewRow] = useState([]);
  const rowId = useRef(0);
  const [documentDate, setDocumentDate] = useState(new Date());
  const [showMultiSelectModal, setShowMultiSelectModal] = useState(false);

  const isView = Boolean(id && newStoreRequisition.is_post && !isDuplicate);
  const pageTitle = !id || isDuplicate
    ? "Add Store Requisition"
    : isView
      ? "View Store Requisition"
      : "Edit Store Requisition";

  const common_toast = {
    position: "bottom-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  const branchesSelected =
    newStoreRequisition.fbranch !== null &&
    newStoreRequisition.tbranch !== null;

  const requireBranches = () => {
    if (branchesSelected) {
      return true;
    }
    toast.error(`${_t(t("Please select both branches"))}`, common_toast);
    return false;
  };

  const getAvailableStock = async (
    index,
    itemId,
    unitId,
    branchId = newStoreRequisition.fbranch?.id
  ) => {
    if (!branchId) {
      toast.error(`${_t(t("Please select branch"))}`, common_toast);
      return false;
    }
    if (!itemId || !unitId) {
      return false;
    }

    setNewRow((currentRows) => {
      const updated = [...currentRows];
      if (!updated[index]) {
        return currentRows;
      }
      updated[index] = { ...updated[index], stock_qty: "Loading.." };
      return updated;
    });

    const url = BASE_URL + "/settings/get-qty-avgrate";
    const formData = {
      branch_id: branchId,
      item_id: itemId,
      unit_id: unitId,
    };

    try {
      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setNewRow((currentRows) => {
        const updated = [...currentRows];
        if (!updated[index]) {
          return currentRows;
        }
        updated[index] = {
          ...updated[index],
          stock_qty: roundOffStock(Number(res.data.stock_qty) || 0),
        };
        return updated;
      });
      return true;
    } catch (error) {
      setNewRow((currentRows) => {
        const updated = [...currentRows];
        if (updated[index]) {
          updated[index] = { ...updated[index], stock_qty: "" };
        }
        return updated;
      });
      toast.error(`${_t(t("Please try again later"))}`, common_toast);
      return false;
    }
  };

  const hanldeSetEdit = (editStore) => {
    if (!editStore) {
      return;
    }

    setNewStoreRequisition({
      document_no: editStore.document_identity,
      fbranch: editStore.from_branch,
      tbranch: editStore.to_branch,
      remarks: editStore.remarks,
      selectedRemark:
        remarksOptions.find((opt) => opt.value === editStore.remarks) ||
        (editStore.remarks ? { label: "Custom", value: "Custom" } : null),
      is_post: editStore.is_post,
    });
    setDocumentDate(new Date(editStore.document_date));

    if (editStore.store_requisition_detail?.length) {
      const rowArr = editStore.store_requisition_detail.map((item) => {
        const row = {
          id: rowId.current,
          item_name: {
            ...item,
            id: item.item_id,
            name: item.item_name,
          },
          qty: roundOffStock(item.qty),
          unit: {
            id: item.unit_id,
            name: item.unit_name,
          },
          item_units: [],
          base_unit: item.base_unit || "",
          base_qty: item.base_qty || "",
          conversion_qty: item.conversion_qty || "",
          stock_qty: "",
        };
        rowId.current += 1;
        return row;
      });
      setNewRow(rowArr);
      rowArr.forEach((row, index) => {
        if (row.item_name?.id && row.unit?.id && editStore.from_branch?.id) {
          getAvailableStock(
            index,
            row.item_name.id,
            row.unit.id,
            editStore.from_branch.id
          );
        }
      });
    }
  };

  const getStoreRequisition = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/storeRequisition/" + parseInt(id);
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res) {
        hanldeSetEdit(res.data);
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getStoreRequisition();
    }
  }, [id]);

  const openMultiSelectModal = () => {
    if (requireBranches()) {
      setShowMultiSelectModal(true);
    }
  };

  const getUnits = async (item, index) => {
    const url = BASE_URL + "/settings/get-unit_item/" + item;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res.data) {
        const selectedUnit = res.data[1] ?? "";
        setNewRow((currentRows) => {
          const updated = [...currentRows];
          if (!updated[index]) {
            return currentRows;
          }
          updated[index] = {
            ...updated[index],
            item_units: res.data,
            unit: selectedUnit,
            conversion_qty: selectedUnit?.qty ?? "",
            base_unit: res.data[0]?.id ?? "",
          };
          return updated;
        });
        if (selectedUnit?.id) {
          getAvailableStock(index, item, selectedUnit.id);
        }
      }
    } catch (error) {
      console.log("check error", error);
    }
  };

  const handleSetItems = (index, item) => {
    setNewRow((currentRows) => {
      const updated = [...currentRows];
      updated[index] = {
        ...updated[index],
        item_name: item,
        unit: "",
        qty: "",
        base_unit: "",
        base_qty: "",
        conversion_qty: "",
        item_units: "",
        stock_qty: "",
      };
      return updated;
    });
    getUnits(item.id, index);
  };

  const handleSetUnit = (index, unit) => {
    const itemId = newRow[index]?.item_name?.id;
    setNewRow((currentRows) => {
      const updated = [...currentRows];
      updated[index] = {
        ...updated[index],
        unit,
        qty: "",
        conversion_qty: roundOffStock(unit.qty),
        stock_qty: "Loading..",
      };
      return updated;
    });
    if (itemId && unit?.id) {
      getAvailableStock(index, itemId, unit.id);
    }
  };

  const calBaseQty = (index) => {
    const qty = newRow[index].qty;
    const conversion_qty = newRow[index].conversion_qty;
    if (qty && conversion_qty) {
      return roundOffStock(qty * conversion_qty);
    }
    return "";
  };

  const addNewRow = () => {
    if (!requireBranches()) {
      return;
    }
    const newID = rowId.current;
    setNewRow((pre) => [
      ...pre,
      {
        id: newID,
        item_name: "",
        qty: "",
        unit: "",
        item_units: "",
        base_unit: "",
        base_qty: "",
        conversion_qty: "",
        stock_qty: "",
      },
    ]);
    rowId.current = rowId.current + 1;
  };

  const delRow = (row) => {
    setNewRow((currentRows) => currentRows.filter((item) => row !== item.id));
  };

  const handleAddMultipleItems = (items) => {
    if (!requireBranches()) {
      return;
    }

    const startingRowId = rowId.current;
    const newRowsToAdd = items.map((item, index) => ({
      id: startingRowId + index,
      item_name: item,
      qty: "",
      unit: "",
      item_units: "",
      base_unit: "",
      base_qty: "",
      conversion_qty: "",
      stock_qty: "",
    }));

    setNewRow((pre) => [...pre, ...newRowsToAdd]);
    rowId.current = startingRowId + items.length;

    items.forEach(async (item) => {
      const url = BASE_URL + "/settings/get-unit_item/" + item.id;
      try {
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        if (res.data) {
          const selectedUnit = res.data[1] ?? "";
          let matchedIndex = -1;
          setNewRow((currentRows) => {
            const updated = [...currentRows];
            matchedIndex = updated.findIndex(
              (r) => r.item_name && r.item_name.id === item.id && !r.unit
            );
            if (matchedIndex !== -1) {
              updated[matchedIndex] = {
                ...updated[matchedIndex],
                item_units: res.data,
                unit: selectedUnit,
                conversion_qty: selectedUnit?.qty ?? "",
                base_unit: res.data[0]?.id ?? "",
                stock_qty: selectedUnit?.id ? "Loading.." : "",
              };
            }
            return updated;
          });
          if (matchedIndex !== -1 && selectedUnit?.id) {
            getAvailableStock(matchedIndex, item.id, selectedUnit.id);
          }
        }
      } catch (error) {
        console.log("check error", error);
      }
    });
  };

  const handleItemQty = (index, e) => {
    const qty = e?.target?.value ?? "";
    setNewRow((currentRows) => {
      const updated = [...currentRows];
      if (!updated[index]) {
        return currentRows;
      }
      updated[index] = { ...updated[index], qty };
      return updated;
    });
  };

  const handleSetBranch = (fbranch) => {
    setNewStoreRequisition({
      ...newStoreRequisition,
      fbranch,
      tbranch: null,
    });
    setNewRow((currentRows) =>
      currentRows.map((row) => ({ ...row, stock_qty: "" }))
    );
    newRow.forEach((row, index) => {
      if (row.item_name?.id && row.unit?.id && fbranch?.id) {
        getAvailableStock(index, row.item_name.id, row.unit.id, fbranch.id);
      }
    });
  };

  const handleSetToBranch = (tbranch) => {
    setNewStoreRequisition({ ...newStoreRequisition, tbranch });
  };

  const handleRemarks = (e) => {
    setNewStoreRequisition({
      ...newStoreRequisition,
      remarks: e.target.value,
    });
  };

  const handleRemarkOption = (selected) => {
    if (selected.value === "Custom") {
      setNewStoreRequisition({
        ...newStoreRequisition,
        selectedRemark: selected,
        remarks: "",
      });
      return;
    }
    setNewStoreRequisition({
      ...newStoreRequisition,
      selectedRemark: selected,
      remarks: selected.value,
    });
  };

  const storeItemAxios = async () => {
    const date =
      new Date(documentDate).getFullYear() +
      "-" +
      (new Date(documentDate).getMonth() + 1) +
      "-" +
      new Date(documentDate).getDate();

    const slugArray = [];
    const duplicate = {};
    const duplicateItem = [];

    newRow.forEach((newStoreItem, index) => {
      if (newStoreItem.item_name && duplicate[newStoreItem.item_name.id]) {
        duplicateItem.push({
          item_id: newStoreItem.item_name.id,
          item_name: newStoreItem.item_name.name,
        });
      }
      if (newStoreItem.item_name === "" || newStoreItem.unit === "") {
        slugArray.push();
      } else {
        duplicate[newStoreItem.item_name.id] = true;
        slugArray.push({
          qty: parseFloat(newStoreItem.qty),
          item_id: newStoreItem.item_name.id,
          item_name: newStoreItem.item_name.name,
          unit_id: newStoreItem.unit.id,
          unit_name: newStoreItem.unit.name,
          base_unit: newStoreItem.base_unit,
          base_qty: calBaseQty(index),
          conversion_qty: parseFloat(newStoreItem.conversion_qty),
        });
      }
    });

    if (duplicateItem.length) {
      toast.error(
        `${_t(t(`Duplicate item ${duplicateItem[0].item_name} found`))}`,
        common_toast
      );
      return;
    }

    if (newRow.length !== slugArray.length) {
      toast.error(`${_t(t("Please select all dropdowns"))}`, common_toast);
      return;
    }

    const isUpdate = id && !isDuplicate;
    setLoading(true);
    const formData = {
      ...(id && { id }),
      from_branch: newStoreRequisition.fbranch.id,
      to_branch: newStoreRequisition.tbranch.id,
      document_date: date,
      remarks: newStoreRequisition.remarks,
      items: slugArray,
    };
    const endPoint = isUpdate
      ? "/settings/storeRequisition/" + parseInt(id)
      : "/settings/storeRequisition";
    const method = isUpdate ? "put" : "post";
    const url = BASE_URL + endPoint;

    try {
      const res = await axios[method](url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (id && Array.isArray(res.data)) {
        setStoreRequisitionList(res.data[0]);
        setStoreRequisitionForSearch(res.data[1]);
      }
      setLoading(false);
      toast.success(
        `${_t(
          t(
            `Store Requisition has been ${isUpdate ? "updated" : "added"}`
          )
        )}`,
        common_toast
      );
      history.push("/dashboard/manage/stock/store-requisition");
    } catch (error) {
      console.log("check error==>", error);
      setLoading(false);
      if (error?.response?.data?.status === 0) {
        toast.error(error.response.data.message, common_toast);
        return;
      }
      toast.error(`${_t(t("Please try again later"))}`, common_toast);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newStoreRequisition.fbranch !== null &&
      newStoreRequisition.tbranch !== null &&
      newStoreRequisition.document_no !== null &&
      documentDate !== null
    ) {
      if (newRow.length > 0) {
        storeItemAxios();
      } else {
        toast.error(`${_t(t("Please add stocks"))}`, common_toast);
      }
    } else {
      toast.error(
        `${_t(t("Please fill all the required fields"))}`,
        common_toast
      );
    }
  };

  return (
    <>
      <Helmet>
        <title>{_t(t(pageTitle))}</title>
      </Helmet>

      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>

            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {loading === true ? (
                      tableLoading()
                    ) : (
                      <div key="smtp-form">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {_t(t(pageTitle))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center"></div>
                          </div>
                        </div>

                        <form
                          className="row card p-2 mx-3 mb-5 table-text"
                          onSubmit={handleSubmit}
                          autoComplete="off"
                        >
                          <div className="col-12">
                            <div className="row">
                              <div className="form-group col-4 mt-3">
                                <div className="mb-2">
                                  <label
                                    htmlFor="document no"
                                    className="control-label"
                                  >
                                    {_t(t("Document no"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control table-text"
                                    id="document_no"
                                    name="document_no"
                                    value={newStoreRequisition.document_no}
                                    placeholder="Auto no"
                                    required={Boolean(id)}
                                  />
                                </div>
                              </div>

                              <div className="form-group col-4 text-right mt-3">
                                <div className="mb-2 text-left">
                                  <label
                                    htmlFor="transfer_date"
                                    className="control-label"
                                  >
                                    {_t(t("Document Date"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <DatePicker
                                    selected={documentDate}
                                    onChange={(date) => setDocumentDate(date)}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control table-text"
                                    placeholderText={_t(t("Document date"))}
                                    shouldCloseOnSelect={false}
                                    disabled={isView}
                                    required
                                  />
                                </div>
                              </div>

                              <div className="form-group mt-3 col-4">
                                <div className="mb-2">
                                  <label
                                    htmlFor="branch"
                                    className="control-label"
                                  >
                                    {_t(t("From Branch"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <Select
                                  options={branchForSearch ?? []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={newStoreRequisition.fbranch || null}
                                  classNamePrefix="select"
                                  onChange={handleSetBranch}
                                  maxMenuHeight="200px"
                                  styles={customStyle}
                                  placeholder={_t(t("Please from branch")) + ".."}
                                  isDisabled={isView}
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="form-group mt-2 col-4">
                                <div className="mb-2">
                                  <label
                                    htmlFor="branch"
                                    className="control-label"
                                  >
                                    {_t(t("To Branch"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <Select
                                  options={
                                    branchListWeb
                                      ? branchListWeb.filter(
                                          (item) =>
                                            item.id !==
                                            newStoreRequisition?.fbranch?.id
                                        )
                                      : []
                                  }
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={newStoreRequisition.tbranch || null}
                                  classNamePrefix="select"
                                  onChange={handleSetToBranch}
                                  maxMenuHeight="200px"
                                  styles={customStyle}
                                  placeholder={_t(t("Please to branch")) + ".."}
                                  isDisabled={
                                    isView || !newStoreRequisition?.fbranch
                                  }
                                />
                              </div>
                              <div className="form-group mt-2 col-8">
                                <div className="mb-2">
                                  <label
                                    htmlFor="remarks"
                                    className="control-label"
                                  >
                                    {_t(t("Remarks"))}
                                  </label>
                                </div>
                                <div className="row mb-2">
                                  <div className="col-4 pr-0">
                                    <Select
                                      isDisabled={isView}
                                      options={remarksOptions}
                                      value={newStoreRequisition.selectedRemark}
                                      onChange={handleRemarkOption}
                                      className="text-left basic-multi-select"
                                      styles={{
                                        ...customStyle,
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                      }}
                                      menuPosition="fixed"
                                      menuPortalTarget={document.body}
                                      maxMenuHeight="13rem"
                                      classNamePrefix="select"
                                    />
                                  </div>
                                  <div className="col-8">
                                    <textarea
                                      type="text"
                                      className="form-control table-text"
                                      id="remarks"
                                      name="remarks"
                                      onChange={handleRemarks}
                                      value={newStoreRequisition.remarks || ""}
                                      placeholder="Remarks"
                                      style={{ height: "33px" }}
                                      disabled={isView}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            {!isView && (
                              <div className="d-flex justify-content-end mb-2">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary shadow-sm"
                                  style={{ borderRadius: "6px" }}
                                  onClick={openMultiSelectModal}
                                >
                                  <i className="fa fa-tasks mr-1"></i>{" "}
                                  {_t(t("Add Multiple Items"))}
                                </button>
                              </div>
                            )}

                            <div
                              className="table-responsive mt-3 pr-1"
                              style={{ maxHeight: "23rem", overflow: "auto" }}
                            >
                              <table className="table sticky-table-header table-bordered-sm table-hover">
                                <thead className="align-middle">
                                  <tr>
                                    {isView ? (
                                      ""
                                    ) : newRow.length === 0 ? (
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span
                                          className="t-mr-10"
                                          onClick={addNewRow}
                                        >
                                          <i
                                            className="fa fa-plus-circle cursor-pointer btn-add-icon"
                                            style={{ fontSize: "22px" }}
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                      </th>
                                    ) : (
                                      <th
                                        style={{
                                          borderBottomColor: "lightgray",
                                        }}
                                      ></th>
                                    )}
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border table_child"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Item Name"))}
                                      </span>
                                    </th>
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                      style={{ minWidth: "130px" }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Available Stock at Branch"))}
                                      </span>
                                    </th>
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Qty"))}
                                      </span>
                                    </th>
                                   
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Unit"))}
                                      </span>
                                    </th>
                                  </tr>
                                </thead>
                                {newRow && newRow.length > 0 ? (
                                  <tbody className="align-middle">
                                    {newRow.map((item, index) => (
                                      <tr className="align-middle" key={item.id}>
                                        {isView ? (
                                          ""
                                        ) : (
                                          <td
                                            className="table-text text-capitalize align-middle text-center table-firstChild"
                                            style={{ minWidth: "60px" }}
                                          >
                                            {index === newRow.length - 1 && (
                                              <span
                                                className="t-mr-10"
                                                onClick={addNewRow}
                                              >
                                                <i
                                                  className="fa fa-plus-circle btn-add-icon"
                                                  style={{ fontSize: "22px" }}
                                                  aria-hidden="true"
                                                ></i>
                                              </span>
                                            )}
                                            &nbsp;
                                            <i
                                              className="fa fa-minus-circle cursor-pointer text-danger"
                                              style={{ fontSize: "22px" }}
                                              onClick={() => delRow(item.id)}
                                            ></i>
                                          </td>
                                        )}
                                        <td className="table-text text-capitalize align-middle text-center">
                                          <Select
                                            options={
                                              ingredientItemForSearch !== null
                                                ? ingredientItemForSearch
                                                : []
                                            }
                                            components={makeAnimated()}
                                            getOptionLabel={(option) =>
                                              option.name
                                            }
                                            getOptionValue={(option) =>
                                              option.id
                                            }
                                            classNamePrefix="select"
                                            onChange={(e) =>
                                              handleSetItems(index, e)
                                            }
                                            maxMenuHeight="12.8rem"
                                            value={item.item_name}
                                            styles={customStyle}
                                            isMenuOpen={true}
                                            menuPosition="fixed"
                                            className="bank-table-input"
                                            isDisabled={isView}
                                            placeholder={
                                              _t(t("Please select items")) +
                                              ".."
                                            }
                                          />
                                        </td>
                                        <td className="table-text text-capitalize align-middle text-center">
                                          {item.stock_qty === "Loading.."
                                            ? "Loading.."
                                            : item.stock_qty || item.stock_qty === 0
                                              ? `${item.stock_qty}${
                                                  item.unit?.name
                                                    ? ` ${item.unit.name}`
                                                    : ""
                                                }`
                                              : "-"}
                                        </td>
                                        <td className="table-text text-capitalize align-middle text-center">
                                          <input
                                            type="number"
                                            step={qtyAmountPoints()}
                                            min="0"
                                            onKeyDown={(evt) =>
                                              [
                                                "e",
                                                "E",
                                                "+",
                                                "-",
                                                "ArrowUp",
                                                "ArrowDown",
                                              ].includes(evt.key) &&
                                              evt.preventDefault()
                                            }
                                            onWheel={(e) => e.target.blur()}
                                            className="form-control text-center table-Input table-text"
                                            id={item.id}
                                            name={item.id}
                                            onChange={(e) =>
                                              handleItemQty(index, e)
                                            }
                                            value={item.qty || ""}
                                            placeholder="Qty"
                                            required
                                            disabled={isView}
                                          />
                                        </td>
                                 
                                        <td
                                          className="table-text text-capitalize align-middle text-center"
                                          style={{ minWidth: "200px" }}
                                        >
                                          <Select
                                            menuPosition="fixed"
                                            options={
                                              item.item_units
                                                ? item.item_units
                                                : []
                                            }
                                            components={makeAnimated()}
                                            getOptionLabel={(option) =>
                                              option.name
                                            }
                                            getOptionValue={(option) =>
                                              option.id
                                            }
                                            value={item.unit}
                                            classNamePrefix="select"
                                            onChange={(e) =>
                                              handleSetUnit(index, e)
                                            }
                                            menuPlacement={
                                              index >= 1 ? "top" : "bottom"
                                            }
                                            className="bank-table-input"
                                            maxMenuHeight="200px"
                                            styles={customStyle}
                                            isDisabled={
                                              isView || !item.item_units
                                            }
                                            placeholder={
                                              _t(t("please select unit")) +
                                              ".."
                                            }
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                ) : null}
                              </table>
                            </div>

                            <div className="d-flex mt-2 justify-content-end align-items-center">
                              <div className="col-3 d-flex justify-content-end">
                                <button
                                  type="button"
                                  className="btn rounded hov-btn mr-3"
                                  onClick={() =>
                                    history.push(
                                      "/dashboard/manage/stock/store-requisition"
                                    )
                                  }
                                >
                                  <i
                                    className="fa fa-arrow-left"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {_t(t("Back"))}
                                </button>
                                {!isView && (
                                  <button
                                    disabled={loading}
                                    type="submit"
                                    className="btn btn-primary rounded"
                                  >
                                    <i
                                      className="fa fa-floppy-o"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    {_t(t("Save"))}
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <ItemMultiSelectModalForItem
        show={showMultiSelectModal}
        onClose={() => setShowMultiSelectModal(false)}
        onAdd={handleAddMultipleItems}
        items={ingredientItemForSearch || []}
        title="Select Ingredients"
        groupKey="group_name"
      />
    </>
  );
};

export default StoreRequisitionAction;
